import { ComponentProps } from 'react';

type Props = { title: string } & ComponentProps<'iframe'>;

export const PdfViewer = ({ title, ...props }: Props) => {
  return <iframe width="100%" title={title} {...props} />;
};
